import { useState } from "react";
import { ImageOff } from "lucide-react";

// Tries each URL in turn (e-shop thumbnails are sometimes missing), then shows a placeholder icon.
// Product photos are drawn at 70% of their frame, centred, so the whole product stays visible.
export const SafeImg = ({ srcs, alt, className, loading }) => {
  const list = [...new Set(srcs.filter(Boolean))];
  const [i, setI] = useState(0);
  if (i >= list.length) return <ImageOff className="absolute inset-0 m-auto h-8 w-8 text-slate-300" />;
  return (
    <span className="flex h-full w-full items-center justify-center bg-white">
      <img src={list[i]} alt={alt} loading={loading} className={`${className} !h-[70%] !w-[70%] !object-contain`} onError={() => setI((n) => n + 1)} />
    </span>
  );
};
